import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV1 } from './baseQueryV1';

export const familyDetailsApi = createApi({
  reducerPath: 'familyDetailsApi',
  baseQuery: baseQueryV1,
  tagTypes: ['FamilyDetails'],
  endpoints: (builder) => ({
    getFamilyDetails: builder.query({
      query: () => 'family-details',
      transformResponse: (res) => res.data,
      providesTags: ['FamilyDetails'],
    }),
    getFamilyDetailsByUserId: builder.query({
      query: (id) => ({
        url: `family-details/user/${id}`,
        method: 'GET',
      }),
      transformResponse: (res) => res.data,
      providesTags: ['FamilyDetails'],
    }),
    getFamilyDetailById: builder.query({
      query: (id) => ({
        url: `family-details/${id}`,
        method: 'GET',
      }),
      transformResponse: (res) => res.data,
      providesTags: ['FamilyDetails'],
    }),
    addFamilyDetail: builder.mutation({
      query: (familyDetail) => ({
        url: 'family-details',
        method: 'POST',
        body: familyDetail,
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['FamilyDetails'],
    }),
    updateFamilyDetail: builder.mutation({
      query: ({ id, ...familyDetail }) => ({
        url: `family-details/${id}`,
        method: 'PUT',
        body: familyDetail,
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['FamilyDetails'],
    }),
    deleteFamilyDetail: builder.mutation({
      query: ({ id }) => ({
        url: `family-details/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['FamilyDetails'],
    }),
    saveBulkFamilyDetails: builder.mutation({
      query: ({ userId, members }) => ({
        url: `family-details/user/${userId}/bulk`,
        method: 'PUT',
        body: { members },
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['FamilyDetails'],
    }),
  }),
});

export const {
  useGetFamilyDetailsQuery,
  useGetFamilyDetailsByUserIdQuery,
  useGetFamilyDetailByIdQuery,
  useAddFamilyDetailMutation,
  useUpdateFamilyDetailMutation,
  useDeleteFamilyDetailMutation,
  useSaveBulkFamilyDetailsMutation,
} = familyDetailsApi;
